import mediaApi from '../../../Api/media-library';

export default {
    methods: {
        getImageUrl(mediaId, settings){
            let {
                crop,
                rotation
            } = settings;
            
            let url =  mediaApi.getPublicImageUrl(mediaId);
            crop = crop || {x: 0, y: 0, w: 0, h: 0};
            rotation = rotation || 0;
            
            //Ensure our url contains a queryString
            if(url.indexOf('?') === -1){
                url += '?v=1';
            }

            //Now we can safely append our crop parameters
            //this should cause Vue to reload our image upon a change in crop
            url += `&cx=${crop.x}&cy=${crop.y}&cw=${crop.w}&ch=${crop.h}&rd=${rotation}`;
            
            return url;
        }
    }
};